import React from 'react'
import Input from '../../ui/Inputs/index';
import { testInputValues, lessonInputValues,  subjectInputValues } from '../../../utils/inputValues';
import Button from '../../ui/Buttons/index';
const FormLayout = () => {
  return (
    <div className='p-[12px] md:p-[16px]'>
        <form>
        <Input label="Sınav" data={testInputValues}/>
        <Input label="Ders" data={lessonInputValues}/>
        <Input label="Konu" data={subjectInputValues}/>
        <Button value="Onayla" path="/smarttest/subject/mode"/>
        </form>
    </div>
  )
}

export default FormLayout